<template>
  <div>
    <a @click="fnShowModal()" class="p-2"
      ><i class="far fa-edit text-primary"></i
    ></a>

    <b-modal ref="modal" hide-footer title="Title">
      <div class="d-block">
        <form>
          <div class="form-group">
            <label for="lowerValue">Lower value</label>
            <input
              type="number"
              step="any"
              class="form-control"
              id="first"
              placeholder="Lower value"
              v-model="lowerValue"
            />
            <div class="invalid-feedback" v-if="errors.lowerValue">
              {{ errors.lowerValue[0] }}
            </div>
          </div>
          <div class="form-group">
            <label for="upperValue">Upper value</label>
            <input
              type="number"
              step="any"
              class="form-control"
              id="upperValue"
              placeholder="Upper value"
              v-model="upperValue"
            />
            <div class="invalid-feedback" v-if="errors.upperValue">
              {{ errors.upperValue[0] }}
            </div>
          </div>
          <div class="form-group">
            <label for="taxRate">Tax rate</label>
            <input
              type="number"
              step="any"
              class="form-control"
              id="taxRate"
              placeholder="Tax rate"
              v-model="TaxRate"
            />
            <div class="invalid-feedback" v-if="errors.TaxRate">
              {{ errors.TaxRate[0] }}
            </div>
          </div>
          <b-form-checkbox
            id="checkbox-1"
            v-model="status"
            name="checkbox-1"
            value="1"
            unchecked-value="0"
          >
            Status
          </b-form-checkbox>
          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button
              type="button"
              @click="fnUpdate()"
              class="btn btn-success btn-sm"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as messageService from '../../services/message.service'
import * as taxTableService from '../../services/taxTable.service'
export default {
  name: 'ModelTaxTableEdit',
  props: ['propsData'],
  components: {},
  data() {
    return {
      errors: {},
      id: '',
      lowerValue: '',
      upperValue: '',
      TaxRate: '',
      status: ''
    }
  },
  computed: {
    ...mapGetters(['getTaxTableAll'])
  },
  methods: {
    ...mapActions(['fetchTaxTableAll']),
    fnShowModal() {
      this.fnGetValue(this.propsData)
      this.showModal()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    },

    fnGetValue(props) {
      this.id = props.rowData.id
      this.lowerValue = props.rowData.lowerValue
      this.upperValue = props.rowData.upperValue
      this.TaxRate = props.rowData.TaxRate
      this.status = props.rowData.status
    },

    fnUpdate: async function () {
      const obj = {
        lowerValue: this.lowerValue,
        upperValue: this.upperValue,
        TaxRate: this.TaxRate,
        status: this.status
      }
      try {
        await taxTableService.update(this.id, obj)
        this.fetchTaxTableAll()
        messageService.fnSweetAlertSuccessToast(
          'Tax table',
          'Updated successfully'
        )
        this.hideModal()

        this.id = ''
        this.lowerValue = ''
        this.upperValue = ''
        this.TaxRate = ''
        this.status = ''
      } catch (error) {
        messageService.fnSweetAlertErrorToast(
          'Tax table - update',
          error.response.data.message
        )
      }
    }
  }
}
</script>